import { render, staticRenderFns } from "./ScheduleList.vue?vue&type=template&id=252cc0fa&"
import script from "./ScheduleList.vue?vue&type=script&lang=js&"
export * from "./ScheduleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports